<fhlb-modal-2 id="dcamountinconsistent" [title]="cmsModel.DCAmountInconsistentTitle" class="font-color-gray" [showHeader]="true" [topBorder]="topBorderClass" >
  <div class="pt-3">
    <p class="modal-paragraph font-size-2 text-align-left" [innerHtml]="cmsModel.DCAmountInconsistent"></p>
    <div class="text-center padding-top-10px">
      <input type="button" class="btn btn-default blackButton margin-right-20px" value="CONTINUE" (click)="goToDcLanding()" />
    </div>
  </div>
</fhlb-modal-2>
